import type { Filter } from '@ahd/shared/types/ahd-fleet/filter';

import { FilterOrder, FilterSort } from '@ahd/shared/types/ahd-fleet-api/mobile/AdQuery';

export const standardFilter: Filter = {
    sort: null,
    order: null,
    fd: [],
    location: [],
    ort: [],
    make: null,
    model: null,
    category: null,
    usedCarSeal: '',
    condition: [],
    price: null,
    priceTo: null,
    firstRegistration: null,
    firstRegistrationFrom: null,
    power: null,
    mileage: null,
    rate: null,
    fuel: null,
    gearbox: null,
    available: null,
    accessoirs: [],
    tags: '-100',
    moreCars: 1,
    pageSize: 18,
    searchText: '',
    exteriorColor: [],
    special: null,
};

export const mockFilter: Filter = {
    sort: FilterSort.Erstelldatum,
    order: FilterOrder.ASC,
    fd: ['fin', 'leas_business'],
    location: ['12345', '67890'],
    ort: ['dresden', 'leipzig'],
    make: 'vw',
    model: 'id3',
    // @ts-expect-error
    category: 'Caravan',
    usedCarSeal: '',
    // @ts-expect-error
    condition: ['NEW'],
    price: [1000, 15000],
    firstRegistration: [2020, 2025],
    power: [80, 120],
    mileage: [10000, 50000],
    rate: [50, 500],
    // @ts-expect-error
    fuel: ['DIESEL', 'PETROL'],
    // @ts-expect-error
    gearbox: ['AUTOMATIC_GEAR'],
    available: true,
    accessoirs: ['123'],
    tags: '-100',
    moreCars: 1,
    pageSize: 18,
    searchText: 'LALALA',
    exteriorColor: ['grey'],
    special: true,
};
